// extracted by mini-css-extract-plugin
export default {"GemTray":"GemTray_GemTray__D88hM"};